import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../contexts/ToastContext";
import Loader from "../../components/elements/Loader";
import { useAuth } from "../../contexts/AuthContext";
import { checkAccountStatus } from "../../services/profileService";

const StripeAccountSuccess = () => {
  const { showSuccessToast, showErrorToast } = useToast();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    checkStripeConnection();
  }, []);

  const checkStripeConnection = async () => {
    if (user && user.stripe_account_id) {
      const res = await checkAccountStatus();
      const account = res.data.data.account;

      if (
        account &&
        account.details_submitted &&
        account.charges_enabled &&
        account.payouts_enabled
      ) {
        showSuccessToast("You are successfully connected to Stripe.");
        navigate("/profile");
      } else {
        showErrorToast(
          'Stripe account connection failed. Please click "Connect with Stripe" to restart the onboarding process.'
        );
        navigate("/profile");
      }
    }
  };

  return <Loader />;
};

export default StripeAccountSuccess;
